<script>

  import Icon from '@iconify/svelte';

  import Logo from '@components/Logo.svelte'

  import { configStore as config } from '@kit/stores';

  import { loadBuildInfo } from '@kit/buildInfo';

  import twitterIcon   from '@iconify-icons/mdi/twitter';
  import facebookIcon  from '@iconify-icons/mdi/facebook';
  import instagramIcon from '@iconify-icons/mdi/instagram';

  import { onclick as showContactForm } from '@components/ContactForm.svelte';

  const isProduction = !window.config?.dev;
  const buildInfo = loadBuildInfo();

  let screenStatus = '';

  /*
  $effect(() => {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const devicePixelRatio = window.devicePixelRatio;
    const dpi = devicePixelRatio * 96; // 96 is default browser DPI

    console.log(`Viewport: ${viewportWidth}x${viewportHeight}, Screen: ${screenWidth}x${screenHeight}, DPR: ${devicePixelRatio}, DPI: ${dpi}`);
  });
   */

</script>

<style>
  footer {
    margin-top: calc(var(--pico-spacing) * 8);
    border-top: 1px solid var(--pico-muted-border-color);

    div.grid {
      width: fit-content;
      margin-inline: auto;
      padding: var(--pico-spacing) calc(var(--pico-spacing) * 3);
      grid-template-columns: repeat(3, 1fr);

      > div { margin-inline: auto; }

      div.grid-column {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-inline: 0;

        .footer-icons {
          display: flex;
          width: 10rem;
          justify-content: space-between;
          align-items: center;
          a {
            display: inline-block;
            margin: auto;
            border-radius: var(--pico-border-radius);
            color: var(--pico-contrast);
          }
        }
      }
    }
  }

  @media mobile {
    div.grid {
      &, h4 {
        font-size: 110%;
      }
      ul li {
      margin-bottom: 1rem;
      }
    }
  }

  Logo {
    margin-bottom: 1rem;
  }
  footer h4 {
    margin-bottom: calc(var(--pico-typography-spacing-vertical) * 0.75);
  }
  footer ul, footer ul li {
    list-style-type: none;
    padding: 0;
  }
  footer a {
    text-decoration: none;
    color: var(--pico-secondary);
    transition: color var(--pico-transition);
    cursor: pointer;
  }
  footer a:hover {
    color: var(--pico-primary);
    text-decoration: var(--pico-text-decoration);
  }
  div.copyright {
    border-top: 1px solid var(--pico-muted-border-color);
    flex-basis: 100%;
    text-align: center;
    padding: var(--pico-spacing);

    svg {
      width: 1.35rem;
      color: red;
    }

  }
  small {
    color: var(--pico-muted-color);
  }
</style>

<footer class="container">
  <div class="grid">
    <div class="grid-column">
      <Logo />
      <div class="footer-icons">
        <a href="#" aria-label="Twitter"><Icon icon={twitterIcon} /></a>
        <a href="#" aria-label="Facebook"><Icon icon={facebookIcon} /></a>
        <a href="#" aria-label="Instagram"><Icon icon={instagramIcon} /></a>
      </div>
    </div>
    <div>
      <h4>Site</h4>
      <ul>
        <li><a href="/about">About</a></li>
        <li><a onclick={showContactForm}>Contact</a></li>
      </ul>
    </div>
    <div>
      <h4>Legal</h4>
      <ul>
        <li><a href="/imprint">Imprint</a></li>
        <li><a href="/terms">Terms</a></li>
        <li><a href="/privacy">Privacy policy</a></li>
      </ul>
    </div>
  </div>
  <div class="copyright">
    <strong>© 2026 carbon.berlin</strong>.
    <p>
    Crafted with <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z"></path></svg> in Berlin.
    All rights reserved.
    </p>

    <small>
      {#if isProduction}
        Production mode
      {:else}
        Development mode
      {/if}
      {#if buildInfo}
        &mdash; Last build: {buildInfo.lastBuildTimestamp} &mdash; v{buildInfo.buildNumber}
      {/if}
    </small>
  </div>

</footer>
